import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { v4 as uuid } from 'uuid';
import { numberFormatterInternational } from 'app/utils/telephonyHelpers';
import { FlowNode, NodeTypeComponent, } from 'fable/flowEditor';
export class InitNode extends NodeTypeComponent() {
    render() {
        const { number } = this.props.extraData;
        const hasPhoneNumber = number && number !== 'local';
        const phoneNumber = hasPhoneNumber
            ? numberFormatterInternational({ phoneNumber: number })
            : '';
        return (_jsx(FlowNode, { color: InitNode.color, icon: InitNode.icon, label: InitNode.label, text: hasPhoneNumber ? (_jsxs("span", { children: ["To ", _jsx("strong", { children: phoneNumber })] })) : (_jsx("span", { children: _jsx("strong", { children: "Choose a number to assign this flow to" }) })) }));
    }
}
InitNode.icon = 'phone';
InitNode.label = 'Incoming call';
InitNode.translatePayload = (node) => {
    return [
        {
            connection: node.childIds.length === 1 ? node.childIds[0] : null,
            id: uuid(),
            label: 'arrow',
            type: 'out',
        },
    ];
};
InitNode.updateConnection = (node, _port, newConnection) => (Object.assign(Object.assign({}, node), { childIds: [newConnection] }));
